// extracted by mini-css-extract-plugin
export default {"text":"ReadMoreText_text__6o-6H","toggle":"ReadMoreText_toggle__2-b8i","clamped":"ReadMoreText_clamped__YQ9GF"};